const translations = {
  emailVerification: 'EMAIL VERIFICATION',
  successMessage:
    'Your email has been successfully verified. You can close this page.',
  errorMessage: 'Something went wrong. Try to resend verification link.',
  resentLink: 'Resend verification link',
};

export default translations;
